import $ from "jquery";
import InitGridObj from "../../dx/dxInitUtils/initGridObj";
import dhtmlXTreeObject from '../../dx/dxSource/components/dhtmlXTreeObject';
import {GoingUtils, AssertUtils, StorageUtils, QueryCommand} from "goingutils";
import GoTabUrl from "./goTabsUrl";

import {
    _dataFromMap,
    _getAccountChange,
    _getAlSelSearchInput,
    _getGroupCheckBox,
    _getSearchInput
} from "../../jsCom/goAclDialog/comJs";


//单选操作
function _gridSingleSelRecord(cellObj, rowId, selVal) {
    //循环已选数据 删除已选的数据
    let alreadGrid = cellObj.alreadySelGrid;
    alreadGrid.forEachRow(function (rowId) {
        alreadGrid.deleteRow(rowId);
    });
    //根据选中 状态来初始化已选表格
    if (selVal) {
        cellObj.addRecordToAlreadyGrid(rowId);
    } else {
        alreadGrid.deleteRow(rowId);
    }
}

class TabCell {

    constructor() {

        this.panelHeight = 0;
        this.leftTopCellHeight = 0;
        this.skipIds = [];
        this.leftBottomCellHeight = 0;
        this.initFirstData = false;
        this.splitHeight = 9;
        this.topSpaceHeight = 0;
        this.accountId = "";
    }


    /**
     * 获取账套加载标志  如果是groupAdmin则不需要从缓存中获取 如果是单位管理员则需要从缓存中获取
     */
    getLoadFormStorageFlag() {
        let loadFromStorage = false;
        //初始化账套缺省默认值
        if (window.CurrentUtils && window.CurrentUtils.getGroupAdminFlag()) {
            if(window.CurrentUtils._getCurrentUser()!=null){
                this.accountId = window.CurrentUtils._getCurrentUser()["accountId"];
            }else{
                window.CurrentUtils._getCurrentUser(false,(backData)=>{
                    this.accountId=backData["accountId"];
                });
            }
            loadFromStorage = true;
        }
        return loadFromStorage;
    }


    /**
     * 从已经查询的数据中进行筛选
     */
    searchAlReadyRecord(tabCellObj) {
        if(tabCellObj!=null){
            //根据用户名称进行查询
            if(window.prcessAppObj!=null&&window.appObj==null){
                window.appObj=window.prcessAppObj;
            }
            if(tabCellObj.waitSelGrid!=null){
                window.appObj&&window.appObj.$bus&&window.appObj.$bus.$on("cellFilter_"+tabCellObj.waitSelGrid.gridId, function ({cellIndex,cellValue,gridObj}) {
                    gridObj.flushGridByUrl({
                        url: `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/users/getUserByUserName`,
                        params: {realName:cellValue}
                    });
                },true);
            }

        }

        $("#" + this.tabId + "_body").find(".search_al_sel_userName_input_icon").click(()=>{
            let searchText = $("#" + this.tabId + "_body").find(".search_al_sel_userName_input").val();
            this.alreadySelGrid.filterBy(1,function(data){
                return   data.toString().indexOf(searchText)!==-1;  // true - show the related row , false - hide the related row
            });
        });
    }

    _desCommonCtl() {
        //销毁表格
        if (this.alreadySelGrid != null && AssertUtils.isFunction(this.alreadySelGrid.destructor)) {
            console.log("-------销alreadySelGrid对象-----");
            this.alreadySelGrid.destructor();
            this.alreadySelGrid = null;
        }
        //销毁账套选择树
        if (this.accountTreeObj != null && AssertUtils.isFunction(this.accountTreeObj.destructor)) {
            this.accountTreeObj.destructor();
            this.accountTreeObj = null;
        }
    }

    searchAlSelGrid() {
        let val = $("#" + this.tabId + "_body").find(".search_al_sel_userName_input").val();
        this.alreadySelGrid.filterBy(1, val);
    }

    //获取单元格的返回结果
    getBackResult(type) {
        let alreadyGrid = this.alreadySelGrid;
        let backJson = {};
        let ids = [];
        let names = [];
        let dataFroms = [];
        let dataFromLabels=[];
        let recordIds = alreadyGrid.getAllRowIds().split(",");
        //如果id不为空
        if (AssertUtils.isNotEmpty(recordIds)) {
            recordIds.forEach(function (item) {
                ids.push(item);
                names.push(alreadyGrid.getCellValue(item, "realName"));
                dataFromLabels.push(alreadyGrid.getCellValue(item, "dataFrom"));
                dataFroms.push(alreadyGrid.getCellValue(item, "dataFromId"));
            });
        }
        if (type === "Array") {
            backJson["names"] = names;
            backJson["ids"] = ids;
            backJson["dataFroms"] = dataFroms;
            backJson["dataFromLabels"]=dataFromLabels;
        } else {
            backJson["names"] = names.join(GoingUtils.relChart);
            backJson["ids"] = ids.join(GoingUtils.relChart);
            backJson["dataFroms"] = dataFroms.join(GoingUtils.relChart);
            backJson["dataFromLabels"] = dataFromLabels.join(GoingUtils.relChart);
        }
        backJson["accountId"] = this.currentAccountId;
        return backJson;
    }

    //从起源表格  复制到 目标表格中
    addRowsFromOldGrid(oldActiveCell) {
        if (AssertUtils.isNotNull(oldActiveCell) && oldActiveCell.alreadySelGrid) {
            let cellObj = this;
            let ids = oldActiveCell.alreadySelGrid.getAllRowIds().split(",");
            //如果id不为空
            if (AssertUtils.isNotEmpty(ids)) {
                ids.forEach(function (item) {
                    if (AssertUtils.isNotNull(cellObj.addAlreadGridFromOldGrid) && AssertUtils.isFunction(cellObj.addAlreadGridFromOldGrid)) {
                        cellObj.addAlreadGridFromOldGrid(item, oldActiveCell.alreadySelGrid, oldActiveCell.alreadySelGrid.getCellValue(item, "dataFrom"),oldActiveCell.alreadySelGrid.getCellValue(item, "dataFromId"));
                    } else {
                        cellObj.addRecordToAlreadyGrid(item, oldActiveCell.alreadySelGrid, oldActiveCell.alreadySelGrid.getCellValue(item, "dataFrom"),oldActiveCell.alreadySelGrid.getCellValue(item, "dataFromId"));
                    }
                });
            }

        }
    }

    /**
     * 取消全集团选择操作
     */
    clearSelAllAccount() {
        let checkBoxEl = $("#" + this.tabId + "_body").find(".sell-all-account").find(".ivu-checkbox");
        if (checkBoxEl.hasClass("ivu-checkbox-checked")) {
            $(checkBoxEl).attr("class", "ivu-checkbox");
        }
    }

    //激活cell对象
    activeCell(tabObj, oldActiveCell, itemConfig) {
        if (itemConfig != null) {
            this.itemConfig = itemConfig;
        }
        $("#" + this.tabId + "_body")
            .find(".go-common-drop")
            .hide();
        tabObj.activeCell = this;
        //删除激活状态
        $("#" + tabObj.parentId + "_header")
            .find(".go-tabs-tab-active")
            .removeClass("go-tabs-tab-active");
        $("#" + tabObj.parentId + "_body")
            .find(".go-active-tabpane")
            .removeClass("go-active-tabpane");
        //设置激活状态
        $("#" + tabObj.parentId + "_header")
            .find("#" + this.getTabId())
            .addClass("go-tabs-tab-active");
        $("#" + tabObj.parentId + "_body")
            .find("#" + this.getTabBodyId())
            .addClass("go-active-tabpane");
        //如果是第一次激活 则需要激活panel的控件
        if (!this.active) {
            this.active = true;
            this.initTabCellCtl();
        }
        this.addRowsFromOldGrid(oldActiveCell);
        if (oldActiveCell != null) {
            //清空以前选择的表格数据
            oldActiveCell.alreadySelGrid.clearAll();
        }
    }

    //设置账套输入框的显示值
    setAccountInput(val) {
        $("#" + this.tabId + "_body")
            .find(".account_sel input")
            .val(val);
    }

    //设置tab页的状态
    initTabState({accountSel = true, loadDataFun}) {
        //如果账套选择为false 则账套选择为disabled
        if (!accountSel) {
            $("#" + this.tabId + "_body")
                .find(".account_sel input")
                .attr("disabled", "true");
            $("#" + this.tabId + "_body")
                .find(".account_sel")
                .addClass("common_search_disable");
        }
        //如果存在用户定义的loadDataFun 则执行用户定义的loadDataFun
        if (AssertUtils.isFunction(loadDataFun)) {
            loadDataFun(this);
        } else {
            this.loadSysDefData();
        }
    }

    //获取panel左边区域的公共部分
    _getLeftPanelCommonTopHeader(accountWid, searchInputWid, search_label, tabCell, groupCheck = false) {
        return `<div class="filter-bar clearfix">
              <div class="tree-sel-drop pull-left">
                 ${_getAccountChange(accountWid, "请选择账套", tabCell.tabId)}
              </div>
              <div class="search-input pull-left">  
                 ${_getSearchInput(searchInputWid, search_label, tabCell.tabId)}
              </div>
              <div class="check-box pull-left" style="margin-top:2px;display:${groupCheck ? 'block' : 'none'}">
                ${_getGroupCheckBox()}
              </div>
            </div>`;
    }

    //获取部门panel 右边视图的html内容
    _getRightCellContent(panelHeight, cellObj, width) {
        return `<div style="height: 100%;">
            <div class="filter-bar clearfix"> 
                    ${cellObj.getSaveToGroup()}  
               <div class="search-input pull-right" style="margin-right: 10px;">  
                   ${_getAlSelSearchInput(width)}
                </div>
            </div>
             <div class="already-sel-user" style="height: calc(100% - 40px)">
                  <div id="${
            cellObj.tabId
            }_already_sel" style="height: 100%" ></div>
            </div>
         </div>`;
    }

    //加载系统默认数据
    loadSysDefData() {
    }

    /**
     * 初始化账套的缺少信息
     * @param loadFromStorageFlag 是否从缓存中获取
     */
    initAccountDefVal(loadFromStorageFlag, cellObj) {
        //如果用户定义了参数  通过参数来获取账套id 来进行查询和展示
        if (cellObj.goTabs["params"] != null) {
            if (cellObj.itemConfig && cellObj.itemConfig.accountId && AssertUtils.isFunction(cellObj.itemConfig.accountId)) {
                cellObj.itemConfig.accountId(cellObj.goTabs["params"]);
                //设置账套名字
                if (AssertUtils.isFunction(cellObj.itemConfig.accountName)) {
                    $("#" + this.tabId + "_body")
                        .find(".account_sel .account-change-input").val(cellObj.itemConfig.accountName(cellObj.goTabs["params"]));
                }
                this.changeAccountEvent(cellObj.itemConfig.accountId(cellObj.goTabs["params"]), this);
            }
            return void (0);
        }
        //如果存在账套选择功能才需要走这方法
        if (loadFromStorageFlag||cellObj.itemConfig.accountSel) {
            //如果StorageUtils中存在 则根据StorageUtils中账套信息来初始化 如果StorageUtils中不存在 则设置成默认的全集团
            if (AssertUtils.isNotEmpty(StorageUtils.getSessionItem("accountId"))) {
                $("#" + this.tabId + "_body")
                    .find(".account_sel .account-change-input").val(StorageUtils.getSessionItem("accountName") + "");
                this.changeAccountEvent(StorageUtils.getSessionItem("accountId"), this);
            } else {
                this.loadAccountRootRecord(this.tabId);

            }
        } else {
            //执行账套chang方法
            if (window.CurrentUtils && window.CurrentUtils._getCurrentUser() != null) {
                //设置账套id
                $("#" + this.tabId + "_body")
                    .find(".account_sel .account-change-input").val(window.CurrentUtils._getCurrentUser()["tenantName"]);
                this.changeAccountEvent(window.CurrentUtils._getCurrentUser()["accountId"], this);
            }else{
                window.CurrentUtils._getCurrentUser(false,(backData)=>{
                    //设置账套id
                    $("#" + this.tabId + "_body")
                        .find(".account_sel .account-change-input").val(backData["tenantName"]);
                    this.changeAccountEvent(backData["accountId"], this);
                });
            }
        }
    }

    /**
     * 加载集团顶层帐套信息
     */
    loadAccountRootRecord(tabId) {
        let queryCommand = new QueryCommand({url: `${window.SysConfigUtils.go_eplat_adress}${window.projectName.loginDes}/account/getRootTenant`});
        queryCommand.executeQuery({
            successFun: (backData) => {
                if(backData==null){
                    return void(0);
                }
                $("#" + tabId + "_body")
                    .find(".account_sel .account-change-input").val(backData["tenantName"]);
                this.changeAccountEvent(backData["id"], this);
            }
        });
    }


    //初始化账套选择
    initAccountTree(changeAccount) {
        let cellObj = this;

        let accountTreeObj = new dhtmlXTreeObject(
            this.tabId + "_account_sel_div",
            "100%",
            300,
            0
        );
        accountTreeObj.flushTreeByUrl({
            url:GoTabUrl.queryAllAccounts,
            backFun: function (treeObj) {
                setTimeout(()=>{
                    treeObj.openAllItems(0);
                },300);
                //展开子节点信息
                accountTreeObj.openItem("supperAccount");
            }
        });
        //注册树事件
        accountTreeObj.attachEvent("onClick", function (id) {
            //将账套信息缓存起来
            StorageUtils.addSessionItem("accountId", id);
            StorageUtils.addSessionItem("accountName", accountTreeObj.getSelectedItemText(id));
            //将账套树进行隐藏
            $("#" + cellObj.tabId + "_body")
                .find(".account_sel_tree")
                .hide();
            $("#" + cellObj.tabId + "_body")
                .find(".account-change-input")
                .val(accountTreeObj.getSelectedItemText());
            //如果设置了账套切换函数 则执行回调函数
            if (AssertUtils.isFunction(changeAccount)) {
                changeAccount(id, cellObj);
            }
            return true;
        });

        if (window.CurrentUtils._getCurrentUser() != null) {
            let curRecord = window.CurrentUtils._getCurrentUser();
            $("#" + cellObj.tabId + "_body")
                .find(".account-change-input")
                .val(curRecord["tenantName"]);
        }
        cellObj.accountTreeObj = accountTreeObj;
    }

    initDefEvent({
                     topHeight, searchFun, searchAlSelFun = () => {}
                 }) {
        let cellObj = this;
        //账套选择组件的输入框事件
        $("#" + this.tabId + "_body")
            .find(".account_sel input")
            .click(function () {
                //显示子项菜单
                $(this)
                    .closest(".account_sel")
                    .next()
                    .show()
                    .css("top", topHeight);

                //第一次点击才进行初始化 如果已经初始化 则不需要进行显示了
                if (!cellObj.accountTreeObj) {
                    //初始化账套树
                    cellObj.initAccountTree(cellObj.changeAccountEvent);
                }
            });

        $(document.body).click(function (e) {
            let target = $(e.target);
            if (
                !target.is("#" + cellObj.tabId + "_body .account_sel *") &&
                !target.is("#" + cellObj.tabId + "_body .account_sel_tree *") &&
                !target.is("#" + cellObj.tabId + "_body .account_sel_tree")
            ) {
                $("#" + cellObj.tabId + "_body .account_sel_tree").hide();
            }
        });

        //查询搜索框回车事件
        $("#" + this.tabId + "_body").find(".search_userName_input").keydown(function (event) {
            if (event.keyCode === 13) {
                searchFun();
            }
        });

        //查询搜索框的图标点击查询事件
        $("#" + this.tabId + "_body")
            .find(".search_userName_input_icon")
            .click(function () {
                searchFun();
            });

        //查询已选搜索框回车事件
        $("#" + this.tabId + "_body").find(".search_al_sel_userName_input").keydown(function (event) {
            if (event.keyCode === 13) {
                searchAlSelFun();
            }
        });
        //查询已选搜索框查询事件
        $("#" + this.tabId + "_body")
            .find(".search_al_sel_userName_input_icon")
            .click(function () {
                searchAlSelFun();
            });

        //是否点击了全集团
        $("#" + this.tabId + "_body")
            .find(".ivu-checkbox-input")
            .click(function () {
                let accountSellEl = $(this)
                    .closest(".sell-all-account")
                    .find(".ivu-checkbox");
                if (accountSellEl.hasClass("ivu-checkbox-checked")) {
                    accountSellEl.removeClass("ivu-checkbox-checked");
                    cellObj.allCheckBoxClick(false);
                } else {
                    accountSellEl.addClass("ivu-checkbox-checked");
                    cellObj.allCheckBoxClick(true);
                }
            });
    }

    initIconBtnEvent() {
        let cellObj = this;
        //向上的按钮
        $("#" + this.tabId + "_body")
            .find(".record-up-btn")
            .click(function () {
                cellObj.upRecord();
            });
        //向下的按钮
        $("#" + this.tabId + "_body")
            .find(".record-down-btn")
            .click(function () {
                cellObj.downRecord();
            });
    }

    //获取查询输入框的值
    getSearchInputVal() {
        return $("#" + this.tabId + "_body")
            .find(".search_userName_input")
            .val();
    }

    //获取查看全集团的checkBox的值
    getIsSelAllAcount() {
        let flag = false;
        $("#" + this.tabId + "_body")
            .find(".sell-all-account .ivu-checkbox")
            .each(function () {
                if ($(this).hasClass("ivu-checkbox-checked")) {
                    flag = true;
                }
            });
        return flag;
    }

    //执行cell从最小到普通
    executeLeftCellToCommon(tabCellObj) {
        $("#" + tabCellObj.tabId + "_body")
            .find(".depart-tree-div")
            .show()
            .height(tabCellObj.leftTopCellHeight);
        $("#" + tabCellObj.tabId + "_body")
            .find(".wait-sel-user")
            .show()
            .height(tabCellObj.leftBottomCellHeight);

        if (tabCellObj._executeCellChangeAfter != null && AssertUtils.isFunction(tabCellObj._executeCellChangeAfter)) {
            tabCellObj._executeCellChangeAfter(tabCellObj.leftTopCellHeight);
        }
    }

    //执行左边cell的最小化操作
    executeLeftCellMin(tabCellObj) {
        $("#" + tabCellObj.tabId + "_body")
            .find(".wait-sel-user")
            .hide();

        let panelHeight = tabCellObj.panelHeight - tabCellObj.topSpaceHeight - tabCellObj.splitHeight;
        if(tabCellObj.tabIdName==="roleUser"||tabCellObj.tabIdName==="jobLevelUser"){
            panelHeight=panelHeight-50;
        }
        $("#" + tabCellObj.tabId + "_body")
            .find(".depart-tree-div")
            .height(parseFloat(panelHeight + ""));

        if (tabCellObj._executeCellChangeAfter != null && AssertUtils.isFunction(tabCellObj._executeCellChangeAfter)) {
            tabCellObj._executeCellChangeAfter(panelHeight);
        }
    }

    //执行左边cell的最大化操作
    executeLeftCellMax(tabCellObj) {
        $("#" + tabCellObj.tabId + "_body")
            .find(".depart-tree-div")
            .hide();
        $("#" + tabCellObj.tabId + "_body")
            .find(".wait-sel-user")
            .height(parseFloat(tabCellObj.leftTopCellHeight + ""));
    }


    //保存为群组
    getSaveToGroup() {
        if (this.hasSaveGroup) {
            return `<div class="pull-left" style="height: 30px;line-height: 30px;cursor: pointer;">【保存为组】</div>`;
        } else {
            return ``;
        }
    }

    //向上调整记录
    upRecord() {
        let alreadyGrid = this.alreadySelGrid;
        alreadyGrid.moveRowUp(alreadyGrid.getSelectedId());
        alreadyGrid.initColOrderNumCell();
    }

    //向下调整记录
    downRecord() {
        let alreadyGrid = this.alreadySelGrid;
        alreadyGrid.moveRowDown(alreadyGrid.getSelectedId());
        alreadyGrid.initColOrderNumCell();
    }

    delRecordFromAlreadyGrid(rowId) {
        let alreadyGrid = this.alreadySelGrid;
        alreadyGrid.deleteRow(rowId);
    }

    //将数据添加到已选表格中
    addDataToAlreadyGrid(rowId, dataAry) {
        let alreadyGrid = this.alreadySelGrid;
        //如果存在已选数据的表格对象
        if (alreadyGrid != null) {
            //如果不存在 则进行增加 如果存在 则不进行增加
            if (alreadyGrid.getRowIndex(rowId) < 0) {
                alreadyGrid.addRow(rowId, dataAry);
            }
        }
    }

    //将数据添加到已选表格中
    addRecordToAlreadyGrid(rowId, orgGrid, dateFromLabel = "用户",dataFrom="user") {
        let cellObj = this;
        if (!AssertUtils.isNotNull(orgGrid)) {
            orgGrid = this.waitSelGrid;
        }
        let alreadyGrid = this.alreadySelGrid;
        //如果存在已选数据的表格对象
        if (alreadyGrid != null) {
            let dataJson = orgGrid.getRowRecord(rowId);
            //如果不存在 则进行增加 如果存在 则不进行增加
            if (alreadyGrid.getRowIndex(rowId) < 0) {
                alreadyGrid.addRow(rowId, [
                    "",
                    dataJson["realName"] + cellObj.appendAccountName(dataJson, cellObj),
                    "",
                    dateFromLabel,
                    dataFrom
                ]);
            }
        }
    }

    //追加账套信息到选中的数据中
    appendAccountName(dataJson, cellObj) {
        if (cellObj.itemConfig && cellObj.itemConfig.appendAccountLabel && AssertUtils.isNotEmpty(dataJson["accountName"])) {
            return "(" + dataJson["accountName"] + ")";
        } else {
            return "";
        }
    }

    //根据已选的数据 来初始化当前待选表格的选择状态
    initWaitGridSelState() {
        let cellObj = this;
        this.alreadySelGrid.forEachRow(function (rowId) {
            let index = cellObj.waitSelGrid.getRowIndex(rowId);
            if (index >= 0) {
                cellObj.waitSelGrid.setRowIsSelected(rowId, false);
            }
        });
    }

    /**
     * 初始化待选表格对象
     */
    initWaitGrid(gridId, afterLoadFun) {
        let cellObj = this;
        let colSelType = "checkBox";
        if (cellObj.goTabs["count"] === 1) {
            colSelType = "radioBox";
        }
        let gridConfig = {
            queryUrl: null,
            colOrderNum: true,
            colSelType: colSelType,
            colSelBox: true,
            hasPagin: false,
            moreSel: true,
            afterLoadData: function () {
                cellObj.initWaitGridSelState();
                afterLoadFun && afterLoadFun();
            },
            onCheckbox(rowId, cellInd, state) {
                if (cellObj.goTabs["count"] === 1) {
                    _gridSingleSelRecord(cellObj, rowId, state);
                }else{
                    //选中 则选择数据  取消钩钩则删除数据
                    if (state) {
                        cellObj.addRecordToAlreadyGrid(rowId);
                    } else {
                        cellObj.delRecordFromAlreadyGrid(rowId);
                    }
                }
            },
            onClick(rowId, cellInd, vueObj, rowRecord) {
                if (cellObj.goTabs["count"] === 1) {
                    _gridSingleSelRecord(cellObj, rowId, GoingUtils.parseBoolean(rowRecord["selBox"]));
                } else {
                    if (parseFloat(rowRecord["selBox"]) === 0) {
                        cellObj.delRecordFromAlreadyGrid(rowId);
                    } else {
                        cellObj.addRecordToAlreadyGrid(rowId);
                    }
                }
            },
            fieldAry: [
                {
                    id: "realName",
                    required: true,
                    type: "ro",
                    sorting: false,
                    filter:true,
                    align: "left",
                    label: "用户名",
                    width: "*"
                },
                {
                    id: "postName",
                    required: true,
                    type: "ro",
                    sorting: "str",
                    align: "left",
                    label: "岗位",
                    width: "*"
                }
            ]
        };
        //已选数据
        let selGrid = InitGridObj(gridId, gridConfig, null);
        cellObj.waitSelGrid = selGrid;
        $("#" + gridId).find(".objbox").css("overflow-x", "hidden");
    }

    /**
     * 获取待选择数据的表格
     */
    initAlreadyGrid(hasType) {
        let cellObj = this;

        let fieldAry = [
            {
                id: "realName",
                required: true,
                type: "ro",
                sorting: "str",
                align: "left",
                label: "用户名",
                width: "160"
            },
            {
                id: "postName",
                required: true,
                type: "ro",
                sorting: "str",
                align: "left",
                label: "岗位",
                width: "*"
            }
        ];
        if (hasType) {
            fieldAry.push({
                id: "dataFrom",
                required: true,
                type: "ro",
                sorting: "str",
                align: "left",
                label: "数据来源",
                width: "*"
            });
        }
        if (hasType) {
            fieldAry.push({
                id: "dataFromId",
                required: true,
                type: "ro",
                sorting: "str",
                align: "left",
                label: "数据来源",
                width: "*"
            });
        }
        let gridConfig = {
            queryUrl: null,
            colOrderNum: true,
            colSelBox: false,
            hasPagin: false,
            headerBar: false,
            moreSel: true,
            fieldAry,
        };
        //已选数据
        let selGrid = InitGridObj(this.tabId + "_already_sel", gridConfig, null, true);
        cellObj.alreadySelGrid = selGrid;

        //加载初始化数据
        cellObj.addAlreadGridInitData(selGrid, cellObj);
        //注册树事件
        selGrid.attachEvent("onRowDblClicked", function (rId) {
            //存在删除回调 才需要调用
            if (AssertUtils.isNotNull(cellObj.removeSelectedRecord) && AssertUtils.isFunction(cellObj.removeSelectedRecord)) {
                try {
                    cellObj.removeSelectedRecord(rId, selGrid.getCellValue(rId, "dataFrom"));
                } catch (e) {
                    console.log(e, "====error");
                }

            }
            selGrid.deleteRow(rId);
            return true;
        });
    }

    addAlreadGridInitData(selGrid, cellObj) {
        //如果tabs存在而且存在初始化函数
        if (this.goTabs != null && AssertUtils.isFunction(this.goTabs.initFun)) {
            let jsobObj = this.goTabs.initFun();
            //需要初始化返回对象存在 才需要进行下去
            if (jsobObj != null) {
                let {ids, names, tabs, hasType} = jsobObj;
                //如果是数组 则需要进行下转换
                if (AssertUtils.isArray(ids)) {
                    ids = ids.join(GoingUtils.relChart);
                }
                //如果是数组 则需要进行下转换
                if (AssertUtils.isArray(names)) {
                    names = names.join(GoingUtils.relChart);
                }

                let dataFrom = "用户";
                //如果存在
                if (tabs && tabs.length === 1) {
                    dataFrom = _dataFromMap[tabs[0]["id"]];
                }
                if (ids) {
                    let idsAry = ids.split(GoingUtils.relChart);
                    let namesAry = names.split(GoingUtils.relChart);
                    if(hasType){
                        idsAry && idsAry.forEach(function (id, index) {
                            let nameLabel = namesAry[index].split("_");
                            if (AssertUtils.isNotEmpty(id)) {
                                selGrid.addRow(id.split("_")[0], [index, nameLabel[0], "", nameLabel[1], id.split("_")[1]]);
                            }
                        });
                    }else{
                        idsAry && idsAry.forEach(function (id, index) {
                            let nameLabel = namesAry[index].split("_");
                            if (AssertUtils.isNotEmpty(id)) {
                                selGrid.addRow(id, [index, nameLabel]);
                            }
                        });
                    }

                }

                if (AssertUtils.isFunction(cellObj._initDataFun)) {
                    cellObj._initDataFun(ids, names);
                }
            }

        }
    }

    getTabHeader() {
        return `<div class="ivu-tabs-tab " tabId="${this.tabIdName}" id="${
            this.tabId
            }_header" >${this.tabLabel}</div>`;
    }

    getTabBody(panelHeight, itemConfig) {
        let height = parseFloat(panelHeight) - 2 + "px";


        return `<div id="${
            this.tabId
            }_body" class="go-tabs-tabpane" style="height: ${height}">
                  <div class="col-sm-55 pull-left h100b" style="width: 49.66666667%">
                    <div class="acl-cell-div">${this.getLeftCellContent(panelHeight, itemConfig)}</div>
                  </div>
     
      <div class="col-sm-53 pull-left h100b">
         <div class="acl-cell-div">${this.getRightCellContent(
            panelHeight
        )}</div>
      </div>
      <div class="col-sm-07 pull-left h100b">
        <div class="operation-area" style="margin-left: 3px">
           <div class="icon-btn record-up-btn"><i  class="ivu-icon ivu-icon-ios-arrow-dropup" style="font-size: 32px;"></i></div>
           <div class="icon-btn record-down-btn" style="margin-top: 10px;"><i class="ivu-icon ivu-icon-ios-arrow-dropdown" style="font-size: 32px;"></i></div>
        </div>
</div>
</div>`;
    }

    getTabId() {
        return this.tabId + "_header";
    }

    getTabBodyId() {
        return this.tabId + "_body";
    }
}

export default TabCell;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/TabCell.js